import { makeStyles } from "@mui/styles";

export default makeStyles((theme) => ({
  uploadbutton: {
    backgroundColor: "#CB1A14",
    width: 120,
    height: 39,
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: 500,
    gap: 5,
    color: "white",
    position: "relative",
    zIndex: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  previewsubheader: {
    display: "flex",
    justifyContent: "space-between",
    gap: "10px",
    alignItems: "center",
    marginBottom: "8px",
    "& h5": {
      fontWeight: "800",
      fontSize: "24px",
      color: theme.palette.primary.main,
      marginBlock: "0px"
    },
    "& h4": {
      fontWeight: "700",
      fontSize: "14px",
      marginBlock: "0px"
    },
    "& p": {
      fontWeight: "400",
      fontSize: "14px",
      marginBlock: "0px"
    }
  },
  notfound: {
    maxWidth: "300px",
    paddingTop: "15%",
    margin: "auto"
  },
  rightcont: {
    position: "relative",
    backgroundColor: "white",
    height: "calc(100vh - 300px)",
    boxSizing: "border-box",
    padding: "0px 15px 0px 15px",
    overflow: "scroll"
  },
  paddingcont: {
    position: "relative",
    background: "white",
    paddingBlock: "32px",
    "@media (max-width: 590px)": {
      paddingBlock: "14px"
    }
  },
  groupWrapper: {
    marginBottom: "20px",
    textAlign: "left",
    "& p": {
      marginBlock: "0px"
    }
  },
  exportbtn: {
    position: "sticky",
    bottom: "0px",
    left: "18px",
    right: "19px",
    background: "white",
    margin: "0 auto"
  },
  groupTitle: {
    fontWeight: 600,
    fontSize: "14px",
    marginBottom: "4px",
    color: "#222"
  },
  selectedCount: {
    fontSize: "12px",
    color: theme.palette.primary.main
  },
  groupHeader: {
    marginBottom: "14px"
  },
  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    marginBottom: "6px"
  },
  checkboxLabel: {
    fontSize: "14px",
    color: "#444"
  }
}));
